<div class="topbar">
  <!-- Global Search -->
  <div class="search">
    <app-icon name="Search" [size]="16" />
    <input
      type="text"
      placeholder="Пошук: підприємство, ЄДРПОУ, документ…"
      [value]="searchQuery()"
      (input)="onSearch($event)"
      (focus)="onSearchFocus()"
      (blur)="onSearchBlur()"
    />

    <!-- Search Suggestions -->
    @if (showSuggestions()) {
      <div class="search-suggestions">
        <div class="suggestions-content">
          @if (isSearching()) {
            <div class="no-results">Пошук…</div>
          } @else if (searchResults().length > 0) {
            @for (suggestion of searchResults(); track suggestion.entityId) {
              <button class="suggestion-item" (click)="selectSuggestion(suggestion)">
                <span class="suggestion-avatar">
                  <app-icon [name]="suggestion.iconName" [size]="18" />
                </span>
                <div class="suggestion-info">
                  <div class="suggestion-name">{{ suggestion.displayText }}</div>
                  <div class="suggestion-meta">{{ suggestion.typeLabel }}</div>
                </div>
                <app-icon name="ArrowRight" [size]="16" />
              </button>
            }
          } @else {
            <div class="no-results">
              Не знайдено результатів для "{{ searchQuery() }}"
            </div>
          }
        </div>
      </div>
    }
  </div>

  <!-- Support: перемикач організацій (лише для ролі SUPPORT) -->
  @if (isSupport()) {
    <button
      class="org-switcher ml-auto"
      [matMenuTriggerFor]="orgMenu"
      title="Активна організація"
    >
      <app-icon name="Building2" [size]="16" />
      <span class="org-switcher-name">{{ activeOrg()?.organizationName ?? 'Оберіть організацію' }}</span>
      <app-icon name="ChevronDown" [size]="16" />
    </button>
    <mat-menu #orgMenu="matMenu" class="org-menu">
      @for (org of organizations(); track org.id) {
        <button
          mat-menu-item
          [class.active]="org.type === activeOrg()?.type && org.organizationId === activeOrg()?.organizationId"
          (click)="selectOrganization(org)"
        >
          <app-icon name="Building2" [size]="16" />
          <span>{{ org.organizationName }}</span>
          @if (org.type === activeOrg()?.type && org.organizationId === activeOrg()?.organizationId) {
            <app-icon name="Check" [size]="16" />
          }
        </button>
      } @empty {
        <div class="org-menu-empty">Немає доступних організацій</div>
      }
    </mat-menu>
  }

  <!-- Notifications -->
  <button class="icon-btn" [class.ml-auto]="!isSupport()" (click)="toggleNotificationPanel()" title="Сповіщення">
    <app-icon name="Bell" [size]="18" />
    @if (notificationCount() > 0) {
      <span class="notification-badge">{{ notificationCount() > 99 ? '99+' : notificationCount() }}</span>
    }
  </button>

  <!-- User Menu -->
  <button class="av" [matMenuTriggerFor]="userMenu" title="Профіль">
    {{ userName().charAt(0) }}
  </button>
  <mat-menu #userMenu="matMenu" class="user-menu">
    <button mat-menu-item (click)="goToProfile()">
      <app-icon name="User" [size]="16" />
      <span>Профіль</span>
    </button>
    <button mat-menu-item>
      <app-icon name="Settings" [size]="16" />
      <span>Налаштування</span>
    </button>
    <button mat-menu-item>
      <app-icon name="HelpCircle" [size]="16" />
      <span>Допомога</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item class="logout-item" (click)="logout()">
      <app-icon name="LogOut" [size]="16" />
      <span>Вийти</span>
    </button>
  </mat-menu>
</div>

<!-- Notification Panel -->
@if (showNotificationPanel()) {
  <app-notification-panel (close)="closeNotificationPanel()" />
}
